@if (product().bundleType === 'open') {
  <ui-configurable-bundle-catalog-card [product]="product()" [position]="position()"></ui-configurable-bundle-catalog-card>
} @else {

  <div [class.promotion]="isPromotion()" class="wrapper-product-card">
  @if (!displayListView()) {
    <div [class.container-promotion]="isPromotion()" class="header-row">
      @if (isPromotion()) {
        <span>Lekkerland Tipp</span>
      }
    </div>
  }

  <div [class]="wrapperClass()">
    <div class="wrapper-content">
      <ui-product-card-core [product]="product()" [displayListView]="displayListView()" [position]="position()"></ui-product-card-core>
    </div>

    <div [class.no-cart]="!showActions()" [class.no-price]="!productPriceIsVisible()" class="wrapper-prices-and-controls">
      <div class="wrapper-price">
        @if (product().prices; as prices) {
          <ui-product-prices
            [productPrice]="prices"
            [showThousandthsPlace]="true"
          ></ui-product-prices>
        }
      </div>
      @if (actionType() === 'add-to-cart') {
        <ui-add-to-cart
          [orderButtonDisabled]="!productHasPrice()"
          (addToShoppingListClicked)="onAddToShoppingList($event)"
          [sku]="product().sku"
          [defaultAmount]="1"
          [showAddToShoppingList]="true"
          [product]="product()"
          [position]="position()"
        ></ui-add-to-cart>
      }

      @if (actionType() === 'show-product') {
        <div class="product-bundle-button">
          <a [link]="product()" mat-stroked-button uiProductLink>
            Aktion anzeigen
          </a>
        </div>
      }
    </div>
  </div>
</div>
}
